<template>
  <div class="w-full flex flex-col gap-2">
    <label
      class="text-[#121212] font-semibold text-[16px] leading-[24px] flex items-center gap-1"
      style="font-family: 'Open Sans'; font-weight: 600"
    >
      {{ label }}
      <span
        v-if="required"
        class="text-[#E25C5C] font-[500] text-[16px] leading-[24px]"
        >*</span
      >
    </label>

    <select
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      class="w-full h-[46px] text-[#414141] text-[14px] border border-[#CCCCCC] rounded-[8px] px-3 outline-none"
      :class="{ 'border-red-500': errorMessage }"
      style="font-family: 'Open Sans'; font-weight: 400"
    >
      <option value="" disabled>Select an option</option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>

    <!-- Error Message -->
    <p v-if="errorMessage" class="text-red-500 text-[14px]">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  label: String,
  modelValue: String,
  options: Array,
  errorMessage: String,
  required: { type: Boolean, default: false },
});

defineEmits(["update:modelValue"]);
</script>
